<template lang="pug">
  header.header.has-bg
    .center
      .box-top.custom-width
        el-row(:gutter="16")
          el-col(:xs="24", :sm="4", :md="4")
            router-link(:to="{name: 'home'}", :class="collapseMenu?'center':''")
              img.logo(:src="require('@/assets/svg/logo.svg')")
          el-col(:xs="24", :sm="20", :md="20")
            top-menu(:collapse="collapseMenu")
          .clear.margin-top
          el-col(:xs="24", :sm="12", :md="12")
            h2.text-primary(data-aos="fade-up", data-aos-delay="500") Infoproduto - Aula show
            p(data-aos="fade-up", data-aos-delay="600") Nosso mais novo infoproduto AULA SHOW com o professor Eder Bento. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla lacinia diam risus, vitae bibendum sapien iaculis sit amet. Morbi eleifend ipsum vitae lorem gravida, quis scelerisque velit maximus. Praesent ornare, est a fringilla volutpat, nibh diam suscipit mauris, eget maximus nibh ex id magna. Sed tristique ex sed sollicitudin lobortis. Nulla porta porta rhoncus. Phasellus viverra neque at metus fermentum pellentesque. Fusce fringilla luctus purus, vel auctor nibh. Nam volutpat vel magna ac rutrum. Aliquam vitae augue at ipsum tempor ullamcorper.
            div(:class="$root.screenW < 768?'center':''")
              el-button.bold.btn-custom(round, type="danger", data-aos="fade-up", data-aos-delay="600")
                |Venha ser um expert da 2ED
                span.space
                i.el-icon-right
            .margin-top
          el-col(:xs="24", :sm="12", :md="12")
            .header-img
              img(data-aos="fade-left", data-aos-delay="700", :src="require('@/assets/svg/marketing-digital.svg')")
</template>

<script>
  import TopMenu from '@/views/TopMenu'
  export default {
    components: {
      TopMenu
    },
    name: 'top',
    computed: {
      collapseMenu () {
        let self = this
        if (parseInt(self.$root.screenW) < 768) {
          return true
        }
        return false
      },
    },
  }
</script>

<style lang="sass" scoped>
  @import '../../assets/sass/bootloader'
  .header
    min-height: 800px
    position: relative
    overflow: hidden
  .header p
    margin-bottom: 64px
    color: $c-black
  .header.has-bg
    overflow: hidden
    background-image: url(../../assets/svg/header-bg.svg)
    background-position: center -250px
    background-repeat: no-repeat
    @media (max-width: 767px)
      background-position: -350px -50px
  .header-img img
    width: 150%
  h2
    margin-block-start: 0.83em
    margin-block-end: 0.83em
    margin-inline-start: 0px
    margin-inline-end: 0px
    text-transform: unset
    font-style: normal
    font-family: 'Kanit', sans-serif
    font-size: $f-size*2
    color: $c-black
  .box-top
    padding: 8px 0
    @media (max-width: 767px)
      padding: 8px
    .logo
      max-height: 40px
      margin-top: $margin
      &:hover
        cursor: pointer
</style>